module.exports = __webpack_public_path__ + "static/media/graphIcon-active.53129fa1.svg";